<n-slide-window *ngIf="pageReady"
    [visible]="windowVisible"
    [loading]="loading"
    [width]="isSimpleMode ? '6.08rem' : '7.5rem'"
    (onHide)="close()">
    <n-header>
        <h1>{{i18n.configureTitle}}</h1>
        <n-help-link key="serviceldapView"></n-help-link>
        <n-checkbox id="configure_service_ldap_advanced"
            style="margin-left: auto;"
            [label]="i18n.advancedLab"
            [(ngModel)]="advanced">
        </n-checkbox>
    </n-header>

    <n-retry *ngIf="loadFailed" (onRetry)="refresh()"></n-retry>

    <form *ngIf="!loadFailed && vm"
        [simpleMode]="isSimpleMode"
        [errorMessage]="errorMessage"
        [formGroup]="vm"
        [ngClass]="{ 'form-width-simple': isSimpleMode, 'common-form': !isSimpleMode }">
        <n-form-item [label]="i18n.vstoreLab" *ngIf="!isSimpleMode">
            <div class="n-form-item-text">{{data.vstoreName || UNPLACEHOLDER}}</div>
        </n-form-item>
        <n-form-item [labelHide]="true">
            <div class="title-md">{{i18n.serversLab}}</div>
        </n-form-item>
        <!-- 服务器ip地址 -->
        <ng-container>
            <n-form-item class="mt-10"
                [labelHide]="true">
                <div class="interval-10">
                    <button nButton
                        id="file_ldap_add_ipAddress_btn"
                        type="button"
                        [disabled]="addBtnDisabled"
                        [disabledTips]="serverAddressDisabledTip"
                        [label]="i18n.addBtnTitle"
                        (click)="add()">
                    </button>
                    <n-button-group [relateTable]="dt"
                        [items]="[removeBtn, testBtn]">
                    </n-button-group>
                </div>
                <n-tip *ngIf="isAddressEmpty"
                    type="failed"
                    [content]="serverAddressRequiredTip">
                </n-tip>
                <n-data-table #dt
                    class="mt-10 tableHeight"
                    id="file_ldap_ipAddress_table"
                    [data]="tableData"
                    [config]="tableConfig"
                    [columnDefs]="columnDefs"
                    [(selection)]="selection">
                    <!-- ip地址输入框 -->
                    <ng-template nTemplate
                        [meta]="{field: 'serverAddress'}"
                        let-col
                        let-data="rowData">
                        <div class="interval-10"
                            *ngIf="data.editStatus">
                            <input type="text"
                                class="file-serverAddress-input"
                                pInputText
                                [(ngModel)]="data[col.field]"
                                [ngModelOptions]="{standalone: true}"
                                [placeholder]="i18n.ipTip"
                                (blur)="onBlurServerIpAddress(data)"
                                [ngClass]="{'ng-invalid ng-touched': data.isInvalid}">
                            <n-tip *ngIf="data.isInvalid"
                                type="failed"
                                [content]="data.validFailedTips"
                                [styleType]="'tooltip'">
                            </n-tip>
                        </div>
                        <ng-container *ngIf="!data.editStatus">{{data.serverAddress}}</ng-container>
                    </ng-template>
                    <!-- 操作列按钮 -->
                    <ng-template nTemplate
                        [meta]="{field: 'buttons'}"
                        let-col
                        let-data="rowData">
                        <!-- 编辑状态 -->
                        <ng-container *ngIf="data.editStatus">
                            <div class="interval-10 table-opt">
                                <!-- √ 按钮 -->
                                <button class="icon-btn ok"
                                    id="file_server_table_edit_ok_btn_{{data.id}}"
                                    (click)="confirmServerAddress(data)">
                                    <svg class="icon">
                                        <use xlink:href="#icon-ok"></use>
                                    </svg>
                                </button>
                                <!-- X 按钮 -->
                                <button class="icon-btn close"
                                    style="margin-left: auto;"
                                    id="file_server_table_edit_cancel_btn_{{data.id}}"
                                    (click)="cancelModifyServerAddress(data)">
                                    <svg class="icon">
                                        <use xlink:href="#icon-close"></use>
                                    </svg>
                                </button>
                            </div>
                        </ng-container>
                        <!-- 非编辑状态 -->
                        <ng-container *ngIf="!data.editStatus">
                            <div class="interval-10 table-opt">
                                <!-- 修改按钮 -->
                                <button class="icon-btn"
                                    id="file_server_table_item_modify_btn_{{data.id}}"
                                    (click)="modifyServerAddress(data)">
                                    <svg class="icon">
                                        <use xlink:href="#icon-edit"></use>
                                    </svg>
                                </button>
                                <!-- 删除按钮 -->
                                <button class="icon-btn"
                                    style="margin-left: auto;"
                                    id="file_server_table_item_delete_btn_{{data.id}}"
                                    (click)="deleteServerAddress(data)">
                                    <svg class="icon">
                                        <use xlink:href="#icon-delete"></use>
                                    </svg>
                                </button>
                            </div>
                        </ng-container>
                    </ng-template>
                </n-data-table>
            </n-form-item>
        </ng-container>
        <!-- 协议 -->
        <n-form-item [label]="i18n.protocalLab">
            <n-radio-group formControlName="TRANSFERTYPE"
                (onChange)="onProtocalChange($event)">
                <n-radio id="service-ldap-configure-protocal-ldap"
                    [value]="ProtocalE.LDAP">
                    {{str.protocalMap[ProtocalE.LDAP]}}
                </n-radio>
                <n-radio id="service-ldap-configure-protocal-ldaps"
                    [value]="ProtocalE.LDAPS">
                    {{str.protocalMap[ProtocalE.LDAPS]}}
                </n-radio>
            </n-radio-group>
            <n-tip *ngIf="vm.value.TRANSFERTYPE === ProtocalE.LDAP"
                [type]="'abnormal'"
                [content]="i18n.prorocolTip">
            </n-tip>
        </n-form-item>
        <!-- 端口号 -->
        <n-form-item [label]="i18n.portLab"
            [required]="true">
            <n-spinner id="service-ldap-configure-port"
                [min]="1"
                [max]="65535"
                [onlyInput]="true"
                [rangeTip]="true"
                formControlName="PORTNUM">
            </n-spinner>
        </n-form-item>
        <!-- 基准DN -->
        <n-form-item [label]="i18n.baseDNLab"
            [required]="true">
            <input type="text"
                id="service-ldap-configure-basedn"
                nInput
                formControlName="BASEDN">
        </n-form-item>
        <!-- 是否使用AD域账号绑定 -->
        <n-form-item [label]="i18n.bindUsingADLab"
            *ngIf="advanced">
            <n-checkbox id="service-ldap-configure-bind-using-ad"
                formControlName="BINDUSINGADCRED"
                [label]="i18n.yesLab">
            </n-checkbox>
        </n-form-item>
        <n-form-item [labelHide]="true">
            <div class="title-md">{{i18n.bindingLab}}</div>
        </n-form-item>
        <!-- 绑定类型 -->
        <n-form-item [label]="i18n.bindTypeLab">
            <n-radio-group formControlName="BINDLEVEL">
                <n-radio id="service-ldap-configure-bind-type-simple"
                    [value]="BindTypeE.Simple">
                    {{str.bindTypeMap[BindTypeE.Simple]}}
                </n-radio>
                <n-radio id="service-ldap-configure-bind-type-sasl"
                    [value]="BindTypeE.SASL">
                    {{str.bindTypeMap[BindTypeE.SASL]}}
                </n-radio>
            </n-radio-group>
        </n-form-item>
        <!-- 绑定DN -->
        <n-form-item [label]="i18n.bindDNLab" [showAvailableLabel]="simpleModeStyle">
            <input type="text"
                id="service-ldap-configure-binddn"
                nInput
                formControlName="USERNAME">
            <!-- 添加一个隐藏的输入框来欺骗firefox等浏览器的自动填充，离密码框要近 -->
            <input type="text" class="hidden">
        </n-form-item>
        <!-- 绑定密码 -->
        <n-form-item [label]="i18n.bindPasswordLab" [showAvailableLabel]="simpleModeStyle">
            <!-- 添加一个隐藏的输入框来欺骗firefox等浏览器的自动填充 -->
            <input type="password" class="hidden"/>
            <input type="password"
                id="service-ldap-configure-password"
                nInput
                formControlName="PASSWORD"/>
        </n-form-item>
        <!-- 确认绑定密码 -->
        <n-form-item [label]="i18n.confirmBindPasswordLab" [showAvailableLabel]="simpleModeStyle">
            <input type="password"
                id="service-ldap-configure-confirm-password"
                nInput
                formControlName="CONFIRMPASSWORD"
                canPaste/>
        </n-form-item>
        <ng-container *ngIf="advanced">
            <!-- 查询设置 -->
            <n-form-item [labelHide]="true">
                <div class="title-md">{{i18n.searchSettingslab}}</div>
            </n-form-item>
            <!-- 用户所在目录 -->
            <n-form-item [label]="i18n.userDirLab" [showAvailableLabel]="simpleModeStyle">
                <input type="text"
                    id="service-ldap-configure-user-dir"
                    nInput
                    formControlName="USERSUFFIX"/>
            </n-form-item>
            <!-- 用户查找范围 -->
            <n-form-item [label]="i18n.userSearchScopeLab">
                <n-radio-group formControlName="USERSCOPE">
                    <n-radio id="service-ldap-configure-user-scope-subtree"
                        [value]="ScopeE.SubTree">
                        {{str.scopeMap[ScopeE.SubTree]}}
                    </n-radio>
                    <n-radio id="service-ldap-configure-user-scope-onelevel"
                        [value]="ScopeE.OneLevel">
                        {{str.scopeMap[ScopeE.OneLevel]}}
                    </n-radio>
                    <n-radio id="service-ldap-configure-user-scope-base"
                        [value]="ScopeE.Base">
                        {{str.scopeMap[ScopeE.Base]}}
                    </n-radio>
                </n-radio-group>
            </n-form-item>
            <!-- 用户组所在目录 -->
            <n-form-item [label]="i18n.groupDirLab" [showAvailableLabel]="simpleModeStyle">
                <input type="text"
                    id="service-ldap-configure-group-dir"
                    nInput
                    formControlName="GROUPSUFFIX">
            </n-form-item>
            <!-- 用户组查找范围 -->
            <n-form-item [label]="i18n.userGroupSearchScopeLab">
                <n-radio-group formControlName="GROUPSCOPE">
                    <n-radio id="service-ldap-configure-user-scope-subtree"
                        [value]="ScopeE.SubTree">
                        {{str.scopeMap[ScopeE.SubTree]}}
                    </n-radio>
                    <n-radio id="service-ldap-configure-user-scope-onelevel"
                        [value]="ScopeE.OneLevel">
                        {{str.scopeMap[ScopeE.OneLevel]}}
                    </n-radio>
                    <n-radio id="service-ldap-configure-user-scope-base"
                        [value]="ScopeE.Base">
                        {{str.scopeMap[ScopeE.Base]}}
                    </n-radio>
                </n-radio-group>
            </n-form-item>
            <!-- 网络组所在目录 -->
            <n-form-item [label]="i18n.networkGroupDNLab" [showAvailableLabel]="simpleModeStyle">
                <input type="text"
                    id="service-ldap-configure-network-dn"
                    nInput
                    formControlName="NETGROUPDN">
            </n-form-item>
            <!-- 网络组查找范围 -->
            <n-form-item [label]="i18n.networGroupSearchScopeLab">
                <n-radio-group formControlName="NETGROUPSCOPE">
                    <n-radio id="service-ldap-configure-network-scope-subtree"
                        [value]="ScopeE.SubTree">
                        {{str.scopeMap[ScopeE.SubTree]}}
                    </n-radio>
                    <n-radio id="service-ldap-configure-network-scope-onelevel"
                        [value]="ScopeE.OneLevel">
                        {{str.scopeMap[ScopeE.OneLevel]}}
                    </n-radio>
                    <n-radio id="service-ldap-configure-network-scope-base"
                        [value]="ScopeE.Base">
                        {{str.scopeMap[ScopeE.Base]}}
                    </n-radio>
                </n-radio-group>
            </n-form-item>
            <!-- 查询超时时间 -->
            <n-form-item [label]="i18n.queryTimeoutDurationLab"
                [required]="true">
                <n-spinner id="service-ldap-query-timeout"
                    [min]="0"
                    [max]="2147483647"
                    [onlyInput]="true"
                    [rangeTip]="true"
                    formControlName="TIMELIMIT">
                </n-spinner>
            </n-form-item>
            <!-- 连接超时时间 -->
            <n-form-item [label]="i18n.connectTimeoutDurationLab"
                [required]="true">
                <n-spinner id="service-ldap-connect-timeout"
                    [min]="1"
                    [max]="2147483647"
                    [onlyInput]="true"
                    [rangeTip]="true"
                    formControlName="BINDTIMELIMIT">
                </n-spinner>
            </n-form-item>
            <!-- 空闲超时时间 -->
            <n-form-item [label]="i18n.idleTimeoutDurationLab"
                [required]="true">
                <n-spinner id="service-ldap-idle-timeout"
                    [min]="0"
                    [max]="2147483647"
                    [onlyInput]="true"
                    [rangeTip]="true"
                    formControlName="IDLETIMELIMIT">
                </n-spinner>
            </n-form-item>
        </ng-container>
    </form>

    <ng-container *ngIf="advanced">
        <form [errorMessage]="errorMessage"
            [formGroup]="advancedVm"
            [simpleMode]="isSimpleMode"
            [ngClass]="{ 'form-width-simple': isSimpleMode, 'common-form': !isSimpleMode }">
            <n-form-item [labelHide]="true">
                <div class="title-md">{{i18n.ldapLab}}</div>
            </n-form-item>
            <!-- 上次已选LDAP模板 -->
            <n-form-item [label]="i18n.lastSchemaTemplateTypeLab">
                {{str.ldapTemplateTypeMap[advancedData.SCHEMATYPESTORE] || UNPLACEHOLDER}}
            </n-form-item>
            <!-- LDAP模板类型 -->
            <n-form-item [label]="i18n.resetSchemaTemplateTypeLab">
                <n-radio-group formControlName="template"
                    (onChange)="onTempalteChange($event)">
                    <n-radio [value]="1">RFC2307</n-radio>
                    <n-radio [value]="2">AD-IDMU</n-radio>
                </n-radio-group>
            </n-form-item>
            <!-- 用户对象 -->
            <n-form-item [label]="i18n.userObjectLab" [showAvailableLabel]="simpleModeStyle">
                <input type="text"
                    id="service-ldap-configure-user-object"
                    nInput
                    formControlName="POSIXACCOUNTOBJECTCLASS">
            </n-form-item>
            <!-- 用户组对象 -->
            <n-form-item [label]="i18n.userGroupObjectLab" [showAvailableLabel]="simpleModeStyle">
                <input type="text"
                    id="service-ldap-configure-user-group-object"
                    nInput
                    formControlName="POSIXGROUPOBJECTCLASS">
            </n-form-item>
            <!-- 网络组对象 -->
            <n-form-item [label]="i18n.networkGroupObjectLab" [showAvailableLabel]="simpleModeStyle">
                <input type="text"
                    id="service-ldap-configure-network-object"
                    nInput
                    formControlName="NISNETGROUPOBJECTCLASS">
            </n-form-item>
            <!-- uid属性 -->
            <n-form-item [label]="i18n.uidAttributeLab" [showAvailableLabel]="simpleModeStyle">
                <input type="text"
                    id="service-ldap-configure-uid"
                    nInput
                    formControlName="UIDATTRIBUTE">
            </n-form-item>
            <!-- uidNumber属性 -->
            <n-form-item [label]="i18n.uidNumberAttributeLab" [showAvailableLabel]="simpleModeStyle">
                <input type="text"
                    id="service-ldap-configure-uid-number"
                    nInput
                    formControlName="UIDNUMBERATTRIBUTE">
            </n-form-item>
            <!-- gidNumber属性 -->
            <n-form-item [label]="i18n.gidNumberAttributeLab" [showAvailableLabel]="simpleModeStyle">
                <input type="text"
                    id="service-ldap-configure-gid"
                    nInput
                    formControlName="GIDNUMBERATTRIBUTE">
            </n-form-item>
            <!-- 组CN属性 -->
            <n-form-item [label]="i18n.cnForGroupsAttributeLab" [showAvailableLabel]="simpleModeStyle">
                <input type="text"
                    id="service-ldap-configure-cn-for-group"
                    nInput
                    formControlName="CNFORGROUPSATTRIBUTE">
            </n-form-item>
            <!-- 网络组CN属性 -->
            <n-form-item [label]="i18n.cnForNetworkGroupsAttributeLab" [showAvailableLabel]="simpleModeStyle">
                <input type="text"
                    id="service-ldap-configure-cn-for-network"
                    nInput
                    formControlName="CNFORNETGROUPSATTRIBUTE">
            </n-form-item>
            <!-- memberUid属性 -->
            <n-form-item [label]="i18n.memberUidAttributeLab" [showAvailableLabel]="simpleModeStyle">
                <input type="text"
                    id="service-ldap-configure-member-uid"
                    nInput
                    formControlName="MEMBERUIDATTRIBUTE">
            </n-form-item>
            <!-- memberNisNetgroup属性 -->
            <n-form-item [label]="i18n.memberNisNetgroupAttribute" [showAvailableLabel]="simpleModeStyle">
                <input type="text"
                    id="service-ldap-configure-member-nis-net"
                    nInput
                    formControlName="MEMBERNISNETGROUPATTRIBUTE">
            </n-form-item>
            <!-- nisNetgroupTruple属性 -->
            <n-form-item [label]="i18n.nisNetgroupTripleAttributeLab" [showAvailableLabel]="simpleModeStyle">
                <input type="text"
                    id="service-ldap-configure-member-nis-net-triple"
                    nInput
                    formControlName="NISNETGROUPTRIPLEATTRIBUTE">
            </n-form-item>
            <!-- 是否支持RFC2307bis -->
            <n-form-item [label]="i18n.bisSupported">
                <n-checkbox id="service-ldap-configure-member-bis-supported"
                    formControlName="ENABLERFC2307BIS"
                    [label]="i18n.yesLab">
                </n-checkbox>
            </n-form-item>
            <!-- groupOfUniqueNames对象 -->
            <n-form-item [label]="i18n.bisGroupOfUniqueNamesObjectLab" [showAvailableLabel]="simpleModeStyle">
                <input type="text"
                    id="service-ldap-configure-member-bis-group"
                    nInput
                    formControlName="GROUPOFUNIQUENAMESOBJECTCLASS">
            </n-form-item>
            <!-- groupOfUniqueNames对象 -->
            <n-form-item [label]="i18n.bisUniqueMemberAttributeLab" [showAvailableLabel]="simpleModeStyle">
                <input type="text"
                    id="service-ldap-configure-member-nis-unique"
                    nInput
                    formControlName="UNIQUEMEMBERATTRIBUTE">
            </n-form-item>
        </form>
    </ng-container>

    <n-footer>
        <button id="service-ldap-configure-ok-btn"
            nButton
            theme="primary"
            [label]="i18n.okBtn"
            (click)="onOk()">
        </button>
        <button id="service-ldap-configure-cancel-btn"
            nButton
            [label]="i18n.cancelBtn"
            (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
